/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestGetPlanInfoDetailRequest,
  RequestGetPlanInfoListRequest,
  RequestGetReportPlansCsvListRequest,
  RequestRegistPlanRequest,
  RequestUpdatePlanRequest,
  ResponseGetPlanInfoDetailResponse,
  ResponseGetPlanInfoListResponse,
  ResponseGetReportPlansCsvListResponse,
} from '../models/index';
import {
    RequestGetPlanInfoDetailRequestFromJSON,
    RequestGetPlanInfoDetailRequestToJSON,
    RequestGetPlanInfoListRequestFromJSON,
    RequestGetPlanInfoListRequestToJSON,
    RequestGetReportPlansCsvListRequestFromJSON,
    RequestGetReportPlansCsvListRequestToJSON,
    RequestRegistPlanRequestFromJSON,
    RequestRegistPlanRequestToJSON,
    RequestUpdatePlanRequestFromJSON,
    RequestUpdatePlanRequestToJSON,
    ResponseGetPlanInfoDetailResponseFromJSON,
    ResponseGetPlanInfoDetailResponseToJSON,
    ResponseGetPlanInfoListResponseFromJSON,
    ResponseGetPlanInfoListResponseToJSON,
    ResponseGetReportPlansCsvListResponseFromJSON,
    ResponseGetReportPlansCsvListResponseToJSON,
} from '../models/index';

export interface PlansGetPlansInfoDetailPostRequest {
    req: RequestGetPlanInfoDetailRequest;
}

export interface PlansGetPlansInfoListPostRequest {
    req: RequestGetPlanInfoListRequest;
}

export interface PlansGetReportPlansCsvListPostRequest {
    req: RequestGetReportPlansCsvListRequest;
}

export interface PlansRegisterPlansPostRequest {
    req: RequestRegistPlanRequest;
}

export interface PlansUpdateBoxInfoPostRequest {
    req: RequestUpdatePlanRequest;
}

/**
 * 
 */
export class PlansApi extends runtime.BaseAPI {

    /**
     * プラン詳細を取得
     * プラン詳細を取得
     */
    async plansGetPlansInfoDetailPostRaw(requestParameters: PlansGetPlansInfoDetailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetPlanInfoDetailResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling plansGetPlansInfoDetailPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plans/GetPlansInfoDetail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetPlanInfoDetailRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetPlanInfoDetailResponseFromJSON(jsonValue));
    }

    /**
     * プラン詳細を取得
     * プラン詳細を取得
     */
    async plansGetPlansInfoDetailPost(requestParameters: PlansGetPlansInfoDetailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetPlanInfoDetailResponse> {
        const response = await this.plansGetPlansInfoDetailPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プラン一覧を取得
     * プラン一覧を取得
     */
    async plansGetPlansInfoListPostRaw(requestParameters: PlansGetPlansInfoListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetPlanInfoListResponse>>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling plansGetPlansInfoListPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plans/GetPlansInfoList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetPlanInfoListRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetPlanInfoListResponseFromJSON));
    }

    /**
     * プラン一覧を取得
     * プラン一覧を取得
     */
    async plansGetPlansInfoListPost(requestParameters: PlansGetPlansInfoListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetPlanInfoListResponse>> {
        const response = await this.plansGetPlansInfoListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プランCSVデータ取得
     * プランCSVデータ取得
     */
    async plansGetReportPlansCsvListPostRaw(requestParameters: PlansGetReportPlansCsvListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetReportPlansCsvListResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling plansGetReportPlansCsvListPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plans/GetReportPlansCsvList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetReportPlansCsvListRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetReportPlansCsvListResponseFromJSON(jsonValue));
    }

    /**
     * プランCSVデータ取得
     * プランCSVデータ取得
     */
    async plansGetReportPlansCsvListPost(requestParameters: PlansGetReportPlansCsvListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetReportPlansCsvListResponse> {
        const response = await this.plansGetReportPlansCsvListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Plansを登録、AmazonItemsを更新
     * Plansを登録、AmazonItemsを更新
     */
    async plansRegisterPlansPostRaw(requestParameters: PlansRegisterPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling plansRegisterPlansPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plans/RegisterPlans`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestRegistPlanRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Plansを登録、AmazonItemsを更新
     * Plansを登録、AmazonItemsを更新
     */
    async plansRegisterPlansPost(requestParameters: PlansRegisterPlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.plansRegisterPlansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Box情報と出荷数を更新
     * Box情報と出荷数を更新
     */
    async plansUpdateBoxInfoPostRaw(requestParameters: PlansUpdateBoxInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling plansUpdateBoxInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plans/UpdateBoxInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdatePlanRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Box情報と出荷数を更新
     * Box情報と出荷数を更新
     */
    async plansUpdateBoxInfoPost(requestParameters: PlansUpdateBoxInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.plansUpdateBoxInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
